import type { VoidFunctionComponent } from 'react';
import { useSelector } from 'react-redux';

import ProjectType from './ProjectType';
import ProjectVisibility from './ProjectVisibility';
import ProjectLabels from './ProjectLabels';
import Scanned from './Scanned';
import * as ProjectsV2Store from '../../../../redux/projectsV2';
import { FilterKeys, isProjects } from '../../../../../shared/projectsV2';
import useFetchProjectsAction from '../hooks/useFetchProjectsAction';
import Button, { BUTTON_SIZE, BUTTON_TYPE } from '../../../generic/Button';
import type { ProjectsFilter } from '../../../../../shared/projectsV2';
import type { MultiSelectFilterOption } from '../../../generic/Filter/MultiSelectFilter';
import { FilterPanel } from '../../../generic';
import { isFeatureEnabled } from '../../../../helpers/features';
import { SBOM_PORTAL_PRIVATE } from '../../../../../shared/featureFlags/flagNames';

const ProjectsFilters: VoidFunctionComponent = () => {
  const filter = useSelector(ProjectsV2Store.selectors.getFilter) as ProjectsFilter;
  const category = useSelector(ProjectsV2Store.selectors.getCategory);

  const resetAllFilters = useFetchProjectsAction(ProjectsV2Store.actions.resetAllFilters);
  const setFilter = useFetchProjectsAction(ProjectsV2Store.actions.setFilter);

  // disable "reset all filters" link if no filters are active
  const hasFilterApplied = useSelector(ProjectsV2Store.selectors.getHasFilterApplied);
  const shouldDisplayProjectVisibility = isProjects(category) || isFeatureEnabled(SBOM_PORTAL_PRIVATE);

  return (
    <div className="projects-filters">
      <div className="projects-filters-header">
        <span className="projects-filters-header-title">Filters</span>
        <Button
          type={BUTTON_TYPE.TEXT}
          size={BUTTON_SIZE.SMALL}
          onClick={() => hasFilterApplied && resetAllFilters()}
          isDisabled={!hasFilterApplied}
        >
          Reset all filters
        </Button>
      </div>
      <div className="projects-filters__content">
        {isProjects(category) && <ProjectType />}
        {shouldDisplayProjectVisibility && <ProjectVisibility />}
        {isProjects(category) && (
          <FilterPanel>
            <ProjectLabels
              filterLabels={filter.labels ?? []}
              onChange={(items: MultiSelectFilterOption[]) => {
                setFilter({ ...filter, [FilterKeys.Labels]: items.map((i) => i.value) });
              }}
            />
          </FilterPanel>

        )}
        <Scanned />
      </div>
    </div>
  );
};

export default ProjectsFilters;
